import {
  setOrgSearchResultCustomisation,
  setSearchResultCustomisationLoad,
} from "@redux/slices/appStateSlice";
import { setCustomSearchData } from "@redux/slices/searchResultsCustomization";
import { ThemeTokenTypes } from "@scenes/splash-screen/types";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

export const useSearchResultsCustomization = (
  url: string,
  enabled?: boolean,
  type?: string
) => {
  const dispatch = useDispatch();
  const timestamp = Date.now();
  return useQuery({
    queryKey: ["GET_SEARCH_RESULTS_CUSTOM_CONFIG"],
    enabled: enabled,
    queryFn: () =>
      axios.get(url + "?timestamp=" + timestamp).then((data) => {
        if (type === ThemeTokenTypes.ORG) {
          dispatch(setOrgSearchResultCustomisation(data.data));
        }
        if (type === ThemeTokenTypes.COMPANY) {
          dispatch(setSearchResultCustomisationLoad(true));
        }
        dispatch(setCustomSearchData(data.data));
        return data;
      }),
    onError: (err) => {
      console.log("err", err);
    },
  });
};
